import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SellersSection } from '../components/SellersSection';
export const SellersPage = () => {
  return <div className="min-h-screen bg-[#f2f2ed]" data-id="element-1041">
      <Header data-id="element-1042" />
      <main data-id="element-1043">
        <SellersSection data-id="element-1044" />
      </main>
      <Footer data-id="element-1045" />
    </div>;
};